import { Injectable } from '@angular/core';
import { HttpCustomService } from 'app/services/http-custom.service';

@Injectable()
export class UserManagementService {
    errorMessage = '';
    data = [];
    login_url = 'users/login/';
    path = '';
    userBaseUrl = 'users/';

    constructor(
        private customHttpService: HttpCustomService,
    ) { }

    login(userData, callbackLogin) {
        this.path = this.login_url;
        this.customHttpService.postData(userData, this.path, callbackLogin, true);
    }

    signup(user, callBackSignup) {
        this.path = this.userBaseUrl + 'register/';
        this.customHttpService.postData(user, this.path, callBackSignup);
    }

    userList(callBackUserManagement) {
        this.path = this.userBaseUrl + 'get_all/';
        this.customHttpService.fetchData(this.path, callBackUserManagement);
    }

    userRole(role_id, user_id, callBackUserManagement) {
        this.path = this.userBaseUrl + user_id + '/change_role/';
        const role = { 'role': role_id };
        this.customHttpService.postData(role, this.path, callBackUserManagement);
    }

    userVerified(status, user_id, callBackIsActive) {
        this.path = this.userBaseUrl + user_id + '/verify_user/';
        const is_active = { 'is_active': status };
        this.customHttpService.postData(is_active, this.path, callBackIsActive);
    }

    changePassword(user_password, user_id, callBackUserManagement) {
        this.path = this.userBaseUrl + user_id + '/change_password/';
        this.customHttpService.postData(user_password, this.path, callBackUserManagement, true);
    }

    resetPassword(userData, callBackUserManagement) {
        this.path = this.userBaseUrl + userData.id + '/reset_password/';
        this.customHttpService.postData(userData, this.path, callBackUserManagement, true);
    }

    updateProfile(profile, user_id, callBackUserManagement) {
        this.path = this.userBaseUrl + user_id + '/update_profile/';
        this.customHttpService.postData(profile, this.path, callBackUserManagement,true);
    }

    getUserProfile(user_id, callBackUserManagement) {
        this.path = this.userBaseUrl + user_id + '/profile/';
        this.customHttpService.fetchData(this.path, callBackUserManagement);
    }

    editUserProfile(user, user_id, callBackUserManagement) {
        this.path = this.userBaseUrl + user_id + "/update_profile/";
        this.customHttpService.postData(user, this.path, callBackUserManagement, true);
    }

    createUserProfile(user, callBackCreateUser) {
        this.path = this.userBaseUrl + 'register/';
        this.customHttpService.postData(user, this.path, callBackCreateUser, true);
    }

    feedback(user, callBackFeedback) {
        this.path = this.userBaseUrl + "give_feedback/";
        this.customHttpService.postData(user, this.path, callBackFeedback, true);
    }

    getFeedback(callBackUserManagement) {
        this.path = this.userBaseUrl + 'read_feedback/';
        this.customHttpService.fetchData(this.path, callBackUserManagement);
    }

    getChatHistory(user_id, callBackChatHistory) {
        this.path = this.userBaseUrl + user_id + "/chathistory/";
        this.customHttpService.fetchData(this.path, callBackChatHistory);
    }

    saveChatHistory(chat_data, user_id, callBack) {
        this.path = this.userBaseUrl + user_id + "/chathistory/";
        this.customHttpService.postData(chat_data, this.path, callBack);
    }

    getNotification(user_id, callBack) {
        this.path = this.userBaseUrl + user_id + "/notification_management/";
        this.customHttpService.fetchData(this.path, callBack);
    }

    saveNotification(chat_data, user_id, callBack) {
        this.path = this.userBaseUrl + user_id + "/notification_management/";
        this.customHttpService.postData(chat_data, this.path, callBack);
    }

    forgotPassword(user, callbackForgot) {
        this.path = this.userBaseUrl + "forgot_password/";
        this.customHttpService.postData(user, this.path, callbackForgot, true)
    }

    getLanguagePreference(user_id, callBack) {
        this.path = this.userBaseUrl + user_id + "/language/";
        this.customHttpService.fetchData(this.path, callBack);
    }

    postLanguagePreference(user_id, lang_data, callBack) {
        this.path = this.userBaseUrl + user_id + "/language/";
        this.customHttpService.postData(lang_data, this.path, callBack);
    }

    changeFeedbackStatus(feedbackId, feedbackStatus, callBack) {
        this.path = this.userBaseUrl + "modify_feedback/" + feedbackId + "/";
        this.customHttpService.postData(feedbackStatus, this.path, callBack);
    }

    deleteUser(user_id, callBack) {
        this.path = this.userBaseUrl + user_id + "/profile/";
        this.customHttpService.deleteData(this.path, callBack);
    }

    getUserSettings(userId, callBack) {
        const path = this.userBaseUrl + `${userId}/user_settings/`;
        this.customHttpService.fetchData(path, callBack, false);
    }

    setUserSettings(data, userId, callBack) {
        const path = this.userBaseUrl + `${userId}/user_settings/`;
        this.customHttpService.postData(data, path, callBack, false);
    }

    getUsers(callBack) {
        const users = [];
        this.userList((response) => {
            if (response.status) {
                response.data.forEach((user) => {
                    users.push(
                        {
                            "id": user.id,
                            "text": user.username,
                            "name": user.name
                        }
                    )
                });
            }

            callBack(users);
        });
    }

    importExcel (data, callBack) {
        const path = this.userBaseUrl + 'get_all/xl/';
        this.customHttpService.postData(data, path, callBack, true);
    }

    exportData(callBack) {
        const path = this.userBaseUrl + 'get_all/xl/';
        this.customHttpService.fetchData(path, callBack, true);
    }
}
